"use strict";

function distance(p1, p2, min) {
  if (!min) {
    min = 1;
  }

  var dx = p2.x - p1.x;
  var dy = p2.y - p1.y;
  var d = Math.sqrt(dx * dx + dy * dy);
  return Math.max(min, d);
}

module.exports = distance;